import { MouseEvent } from 'react';

/** Keeps a click on a Drive control from reaching the grid row underneath. */
export const stopRowClick = (event: MouseEvent) => event.stopPropagation();
